import { useEffect } from 'react';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';

/**
 * SwUpdateToast — listens for the `girgit:sw-updated` event dispatched by the
 * Service Worker registration script in public/index.html when a new bundle
 * has taken control of the page. Shows a friendly persistent toast inviting
 * the user to refresh, instead of silently reloading and potentially trashing
 * an in-progress form.
 *
 * Mount once at the App root (already done in App.js).
 */
export default function SwUpdateToast() {
  useEffect(() => {
    const handler = () => {
      if (window.location.pathname.startsWith('/sign/') || window.location.pathname.startsWith('/privacy') || window.location.pathname.startsWith('/terms') || window.location.pathname.startsWith('/delete-account')) return;
      toast(
        'A new version of Girgit is ready',
        {
          description: 'Refresh to load the latest features and fixes.',
          duration: Infinity,
          action: {
            label: 'Refresh',
            onClick: () => window.location.reload(),
          },
          icon: <RefreshCw className="w-4 h-4 text-pink-500" />,
        }
      );
    };
    window.addEventListener('girgit:sw-updated', handler);
    return () => window.removeEventListener('girgit:sw-updated', handler);
  }, []);

  return null;
}
